import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CurrentProductService } from '@spartacus/storefront';
import { map } from 'rxjs';

@Component({
  selector: 'product-title',
  template: '<h3>{{productTitle$ | async }}</h3>',
  styleUrl: 'product-title.component.scss',
  imports: [CommonModule],
})
export class ProductTitleComponent {
  protected currentProductService = inject(CurrentProductService);

  productTitle$ = this.currentProductService.getProduct().pipe(map((product) => product?.name));
}
